import React, { useState } from "react";
import {
  Button,
  Carousel,
  CarouselControl,
  CarouselIndicators,
  CarouselItem,
  Col,
  Input,
  Row,
} from "reactstrap";
// import productImage from "../../../../assets/images/product-image.png";
import drugImage from "../../../../../assets/inventory/drug-image.svg";
import sortArrow from "../../../../../assets/inventory/sort-arrows.svg";
import upArrow from "../../../../../assets/inventory/up-arrow.svg";
import downArrow from "../../../../../assets/inventory/down-arrow.svg";

const OrderEditDetails = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [increment, setIncrement] = useState(5);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  const items = [
    {
      src: drugImage,
      key: 1,
      drugName: "Yellow, Oblong, Tablet, LU G13",
    },
    {
      src: drugImage,
      key: 2,
      drugName: "Yellow, Oblong, Tablet, LU G13",
    },
    {
      src: drugImage,
      key: 3,
      drugName: "Yellow, Oblong, Tablet, LU G13",
    },
    {
      src: drugImage,
      key: 4,
      drugName: "Yellow, Oblong, Tablet, LU G13",
    },
  ];
  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        {" "}
        <img
          src={item.src}
          style={{ display: "flex", justifyContent: "center", margin: "auto" }}
        />
        <div className="physical-description" style={{ height: "20px" }}></div>
        <div className="physical-description">Physical Descripitons</div>
        <div className="medicine-name">{item.drugName}</div>
      </CarouselItem>
    );
  });

  return (
    <div className="invOrderDetails">
      <div>
        <Row className="mb-4 mt-2">
          <Col md="4">
            <div className="invHeadDetails">Product Name</div>
            <div className="inv-details">Lisinopril 10mg Tablet</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">NDC/UPC</div>
            <div className="inv-details">34981-3198-99</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Manufacturer</div>
            <div className="inv-details">McKessson</div>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md="4">
            <div className="invHeadDetails">Quantity Required</div>
            <div className="inv-details">3 Bottles</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Par Level</div>
            <div className="inv-details">3000 Tablets</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Quantity On Hand</div>
            <div className="inv-details">500</div>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md="4">
            <div className="invHeadDetails">Package Cost</div>
            <div className="inv-details">$ 89.50</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Unit Cost </div>
            <div className="inv-details">$ 895.000</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Drug Status</div>
            <div className="inv-details">Owed</div>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md="4">
            <div className="invHeadDetails">Allow Substitutes </div>
            <div className="inv-details">Yes</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Account</div>
            <div className="inv-details">MoKesson WAC</div>
          </Col>
          <Col md="4">
            <div className="invHeadDetails">Package Size</div>
            <div className="inv-details">1000 Tablets</div>
          </Col>
        </Row>
      </div>
      <div className="tabletImg">Drug Image</div>
      <Carousel
        className="pt-0"
        slide={false}
        activeIndex={activeIndex}
        next={next}
        previous={previous}
      >
        <CarouselIndicators
          items={items}
          activeIndex={activeIndex}
          onClickHandler={goToIndex}
          style={{ position: "relative", top: "226px" }}
        />
        {slides}

        <CarouselControl
          direction="prev"
          directionText="Previous"
          onClickHandler={previous}
        ></CarouselControl>
        <CarouselControl
          direction="next"
          directionText="Next"
          onClickHandler={next}
        />
      </Carousel>

      <div className="quality-required">
        <Row
          className="d-flex justify-content-between align-items-center"
          style={{ width: "100%", height: "100%" }}
        >
          <Col className="qty-head-text" lg={9}>
            Quantity Required <img src={sortArrow} />
          </Col>
          <Col className="qty-head-text" lg={3}>
            Total Cost <img src={sortArrow} />
          </Col>
        </Row>
      </div>

      <div className="count-num" style={{gap:"12px",    borderBottom: "1px solid #d3d3d3",borderLeft:"none",borderRight:"none"}}>
        {" "}
        <div className="qty-count-edit">
          <div>{increment}</div>
          <div className="d-flex flex-column cursor-pointer">
            <img src={upArrow} onClick={() => setIncrement(increment + 1)} />
            <img src={downArrow} onClick={() => setIncrement(increment - 1)} />
          </div>
        </div>
        <div className="qty-total">
          <div>$</div>
          <div>8769.5</div>
        </div>
      </div>
    </div>
  );
};

export default OrderEditDetails;
